<template>
  <div class="row justify-center">
    <div class="col-auto column">
      <div class="row justify-between">
        <div
          v-for="digit in $_.range(pinLength)"
          :key="digit"
          dense
          maxlength="1"
          class="col-auto pin"
          v-text="pin.length > digit ? '⬤' : ''"
        />
      </div>
      <div
        v-for="row in [[1, 2, 3], [4, 5, 6], [7, 8, 9], ['keyboard_backspace', 0, 'clear']]"
        :key="row[0]"
        class="col row q-gutter-lg q-mt-xs"
      >
        <q-btn
          v-for="num in row"
          :key="num"
          :label="isNaN(num) ? undefined : num"
          :icon="isNaN(num) ? num : undefined"
          :disable="loading || num === null || pin.length === pinLength"
          flat
          size="xl"
          class="col"
          @click="addDigit(num)"
        />
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'PinPad',
  configuration: ['currentCircuit'],
  props: {
    // Enable the parent to do an async task. Setting loading true --> false causes a reset
    // Controls are disabled while loading = true
    loading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['pin-pad-input'],
  data () {
    return {
      pin: '',
      buffer: [],
      bufferTimeout: null
    }
  },
  computed: {
    pinLength () {
      return this.currentCircuit.userPinLength
    }
  },
  watch: {
    loading () {
      if (this.loading === false) {
        this.reset()
      }
    }
  },
  mounted () {
    document.addEventListener('keyup', this.keyupHandler)
  },
  unmounted () {
    document.removeEventListener('keyup', this.keyupHandler)

    if (this.bufferTimeout) {
      clearTimeout(this.bufferTimeout)
    }
  },
  methods: {
    addDigit (digit) {
      if (this.pin.length === this.pinLength || this.loading) return

      if (digit === 'keyboard_backspace' || digit === 'Backspace' || digit === 'Delete') {
        this.pin = this.pin.substr(0, this.pin.length - 1)
        return
      }
      if (digit === 'clear') {
        this.pin = ''
        return
      }

      digit = String(digit)[0] // Ensure only one digit

      if (!'0123456789'.includes(digit)) return

      this.pin += digit

      if (this.pin.length === this.pinLength) {
        this.$emit('pin-pad-input', this.pin)
      }
    },
    keyupHandler (keyEvent, recheck = false) {
      if (!recheck) {
        this.buffer.push(keyEvent.key)
      }
      this.bufferTimeout ||= setTimeout(() => {
        if (this.buffer.length > 2) {
          this.buffer = []
        } else {
          while (this.buffer.length > 0) {
            this.addDigit(this.buffer.pop())
          }
          this.keyupHandler(null, true)
        }
        this.bufferTimeout = null
      }, 100)
    },
    reset () {
      this.pin = ''
    }
  }
}
</script>

<style lang="scss" scoped>
  .pin {
    margin-left: 2px;
    margin-right: 2px;
    padding: 10px 13px;
    border: solid 1px #777;
    border-radius: 5px;
    font-size: 18px;
    width: 50px;
    height: 50px;
  }
</style>
